import React from 'react';
import { Bike, Building, GraduationCap, Mail, Phone, Instagram } from 'lucide-react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-20 pb-10" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        {/* CTA Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-103">
          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-104">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-105">
              <GraduationCap className="w-6 h-6" data-id="element-106" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-107">For Students</h3>
            <p className="text-slate-400 mb-6" data-id="element-108">
              Ready to revolutionize your campus living experience? Join the
              waitlist today.
            </p>
            <Link to="/roommate-match" data-id="element-109">
              <Button className="w-full bg-brand-primary hover:bg-brand-light text-white border-none" data-id="element-110">
                Join Waitlist
              </Button>
            </Link>
          </div>

          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-111">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-112">
              <Bike className="w-6 h-6" data-id="element-113" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-114">Become an Ambassador</h3>
            <p className="text-slate-400 mb-6" data-id="element-115">
              Join the Simba Fleet. Verify properties and earn money while you
              ride.
            </p>
            <Link to="/ambassadors" data-id="element-116">
              <Button variant="outline" className="w-full border-brand-primary/30 text-white hover:bg-brand-dark-secondary hover:text-white hover:border-brand-primary/50" data-id="element-117">
                Apply Now
              </Button>
            </Link>
          </div>

          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-118">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-119">
              <Building className="w-6 h-6" data-id="element-120" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-121">For Landlords</h3>
            <p className="text-slate-400 mb-6" data-id="element-122">
              List your property to access verified tenants and automated rent
              collection.
            </p>
            <Link to="/login" data-id="element-123">
              <Button variant="outline" className="w-full border-brand-primary/30 text-white hover:bg-brand-dark-secondary hover:text-white hover:border-brand-primary/50" data-id="element-124">
                List Property
              </Button>
            </Link>
          </div>
        </div>

        {/* Links & Copyright */}
        <div className="border-t border-brand-primary/20 pt-10" data-id="element-125">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-126">
            {/* Logo & Contact */}
            <div data-id="element-127">
              <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-128">
                <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-8 w-auto brightness-0 invert" data-id="element-129" />
              </Link>
              <p className="text-slate-400 text-sm mb-4" data-id="element-130">
                Making student housing safer across Africa.
              </p>
              <div className="space-y-2" data-id="element-131">
                <a href="mailto:support@campusaparte.com" className="flex items-center gap-2 text-slate-400 hover:text-brand-primary transition-colors text-sm" data-id="element-132">
                  <Mail className="w-4 h-4" data-id="element-133" />
                  support@campusaparte.com
                </a>
                <a href="tel:+2347069243079" className="flex items-center gap-2 text-slate-400 hover:text-brand-primary transition-colors text-sm" data-id="element-134">
                  <Phone className="w-4 h-4" data-id="element-135" />
                  +234 706 924 3079
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-136">
              <h4 className="font-bold text-white mb-4" data-id="element-137">Quick Links</h4>
              <div className="flex flex-col gap-2 text-sm text-slate-400" data-id="element-138">
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-139">
                  About Us
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-140">
                  How It Works
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-141">
                  Safety & Security
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-142">
                  Blog
                </a>
              </div>
            </div>

            {/* Legal */}
            <div data-id="element-143">
              <h4 className="font-bold text-white mb-4" data-id="element-144">Legal</h4>
              <div className="flex flex-col gap-2 text-sm text-slate-400" data-id="element-145">
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-146">
                  Terms of Service
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-147">
                  Privacy Policy
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-148">
                  Cookie Policy
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-149">
                  Support
                </a>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-brand-primary/20 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-150">
            <div className="text-sm text-slate-500" data-id="element-151">
              © {new Date().getFullYear()} CampusAparte. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm text-slate-400" data-id="element-152">
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-153">
                Facebook
              </a>
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-154">
                Twitter
              </a>
              <a href="https://www.instagram.com/campusaparte/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-primary transition-colors flex items-center gap-1" data-id="element-155">
                <Instagram className="w-4 h-4" data-id="element-156" />
                Instagram
              </a>
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-157">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}